import { CountryOptionResource, SingleSelectField, TextField } from "@dgs/core";
import { TFunction } from "i18next";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CountrySelectField } from "../../ui/CountrySelectField";

const typeOptions = ["private", "work", "other"];

export interface BaseAddressValue {
	additionalInfo: string | null;
	street: string;
	houseNumber: string;
	zip: string;
	city: string;
	country: CountryOptionResource | null;
	type: "private" | "work" | "other" | null;
}

export const validateAddress = (t: TFunction, value: BaseAddressValue | null) => {
	const errors: { [K in keyof BaseAddressValue]?: string } = {};
	if (!value?.street) {
		errors.street = t("Field is required");
	}
	if (!value?.houseNumber) {
		errors.houseNumber = t("Field is required");
	}
	if (!value?.zip) {
		errors.zip = t("Field is required");
	}
	if (!value?.city) {
		errors.city = t("Field is required");
	}
	if (!value?.country) {
		errors.country = t("Field is required");
	}
	if (!value?.type) {
		errors.type = t("Field is required");
	}
	return errors;
};

interface Props {
	name: string;
}
export const AddressFormFields: FC<Props> = ({ name }) => {
	const { t } = useTranslation();

	return (
		<>
			<TextField name={`${name}.additionalInfo`} label={t("Additional info")} />
			<TextField name={`${name}.street`} label={t("Street")} required />
			<TextField name={`${name}.houseNumber`} label={t("House number")} required />
			<TextField name={`${name}.zip`} label={t("Zip")} required />
			<TextField name={`${name}.city`} label={t("City")} required />
			<CountrySelectField name={`${name}.country`} label={t("Country")} required />
			<SingleSelectField
				name={`${name}.type`}
				options={typeOptions}
				getLabel={(option) => t(option)}
				getValue={String}
				label={t("Type")}
				clearable={false}
				required
			/>
		</>
	);
};
